type SharePasswordFieldProps = {
  value: string;
  onChange: (value: string) => void;
  hasExistingPassword: boolean;
  placeholderNew: string;
  placeholderEnter: string;
  existingHint: string;
};

export default function SharePasswordField({
  value,
  onChange,
  hasExistingPassword,
  placeholderNew,
  placeholderEnter,
  existingHint,
}: SharePasswordFieldProps) {
  return (
    <div className="space-y-2">
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={hasExistingPassword ? placeholderNew : placeholderEnter}
        className="w-full px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent"
      />
      {hasExistingPassword && !value && (
        <p className="text-xs text-gray-400">{existingHint}</p>
      )}
    </div>
  );
}
